const GENDER_MAP = {
  남: 'M',
  여: 'F',
};

export function normalizePhone(phone) {
  return phone.replace(/\D/g, '');
}

export function buildApplicationPayload(formData, competitions = []) {
  const tournament = competitions.find((t) => t.value === formData.tournament);

  const payload = {
    competitionCode: tournament?.code ?? formData.tournament,
    competitionName: tournament?.name ?? formData.tournament,
    associationName: formData.affiliation.trim(),
    gymName: formData.dojo.trim(),
    coachName: formData.coachName.trim(),
    participantName: formData.name.trim(),
    participantPhone: normalizePhone(formData.phone),
    birth: formData.birthdate,
    gender: GENDER_MAP[formData.gender],
    grade: formData.grade,
  };

  const parentPhone = normalizePhone(formData.guardianPhone);
  if (parentPhone) {
    payload.parentPhone = parentPhone;
  }

  const height = parseFloat(formData.height);
  if (!Number.isNaN(height)) {
    payload.height = height;
  }

  if (tournament?.amount != null) {
    payload.amount = tournament.amount;
  }

  return payload;
}
